import { Dialog, DialogHeader, Typography } from "@material-tailwind/react";
import Register from "../../Auth/Register";
import { DialogContent } from "@mui/material";
import Image from "next/image";
import { SCPB_LOGO, SCPB_LOGOS } from "@/src/constants";

export interface RegisterModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;

  onClose: () => void;
  onComplete: (id: string, email: string) => void;
}

const RegisterModal = ({
  open,
  setOpen,
  onClose,
  onComplete,
}: RegisterModalProps) => {
  return (
    <Dialog handler={setOpen} open={open}>
      <DialogHeader className="flex-col text-left justify-start items-start">
        <div className="w-full flex items-center p-4">
          <div className="w-full h-[4rem] md:h-[6rem] relative">
            <Image fill src={SCPB_LOGOS["Large Blue Black"]} alt="SCPB_LOGO" />
          </div>
        </div>

        <Typography variant="h5">Register</Typography>

        <Typography variant="paragraph">
          Register to subscribe to SCPlaybook
        </Typography>
      </DialogHeader>

      <DialogContent style={{ paddingTop: 0 }}>
        <Register onSuccess={onComplete} buttonText={"Step 1 of 2"} arrow />
      </DialogContent>
    </Dialog>
  );
};

export default RegisterModal;
